import { render, staticRenderFns } from "./DelegationManager.vue?vue&type=template&id=100a6f01&scoped=true&"
import script from "./DelegationManager.vue?vue&type=script&lang=js&"
export * from "./DelegationManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100a6f01",
  null
  
)

export default component.exports